<style>
    .night-mode, label.night-mode {
        color: white;
    }
	table.night-mode td label {
		color: white;
	}
	table {
		width: 100%;
    }
    .trace-highlight {
        color: var(--accent-blue) !important;
    }
</style>
<h4>Trace Results:</h4>
<div class="row">
    <div class="col-md-12">
        <table [ngClass]="{'night-mode': nightMode}">
            <tr>
                <th class="data"><label>Sighting Date</label></th>
                <th class="data"><label>Sighting Location</label></th>
                <th class="data"><label>Sighting Splc</label></th>
                <th class="data"><label>Event</label></th>
                <th class="data"><label>Destination</label></th>
                <th class="data"><label>Destination Splc</label></th>
                <th class="data"><label>Railroad</label></th>
            </tr>
            <tr *ngFor="let traceResult of traceResults">
                <td><label class="data" [ngClass]="{'trace-highlight': traceResult.arrived}">{{traceResult.sightingDate | date: 'MM-dd-yy'}}</label></td>
                <td><label class="data" [ngClass]="{'trace-highlight': traceResult.arrived}">{{traceResult.sightingCity}}, {{traceResult.sightingState}}</label></td>
                <td><label class="data" [ngClass]="{'trace-highlight': traceResult.arrived}">{{traceResult.sightingSPLC}}</label></td>
                <td><label class="data" [ngClass]="{'trace-highlight': traceResult.arrived}">{{traceResult.sightingEventDescription}}</label></td>
                <td><label class="data" [ngClass]="{'trace-highlight': traceResult.arrived}">{{traceResult.destinationCity}}, {{traceResult.destinationState}}</label></td>
                <td><label class="data" [ngClass]="{'trace-highlight': traceResult.arrived}">{{traceResult.destinationSPLC}}</label></td>
                <td><label class="data" [ngClass]="{'trace-highlight': traceResult.arrived}">{{traceResult.reportingRailroadSCAC}}</label></td>
            </tr>
        </table>
    </div>
</div>